import moment from 'moment';

export default {
    data: {
        dashboards: null,
        permissions: null,
        options: {
            importantKeys: [
                'email', 'message', 'bericht', 'comment', 'body', 'name', 'naam',
                'first_name', 'firstname', 'first', 'last_name', 'lastname', 'last',
                'emailaddress', 'e-mailaddress', 'mail', 'workemail', 'company', 'phone', 'telefoonnummer', 'bedrijf',
                'bedrijfsnaam', 'companyname', 'organization', 'telefoon', 'anders', 'contactpersoon',
                'aanhef', 'adres', 'postcode', 'plaats', 'fax', 'contact', 'organisation',
                'salutation', 'contactperson', 'date', 'othertext', 'subject', 'informatie', 'locations',
                'birthday', 'job', 'preference', 'city', 'preamble', 'soortfeest'
            ],
            excludedKeys: ['ip', 'g-recaptcha-response', 'send-contact', 'org-message'],
            hideKeys: [
                'g-recaptcha-response', 'submit', 'plansubmit', 'sxcontact', 'nospam', 'contactsubmit', 'submitoffer',
                'foodbooksubmit'
            ],
            lengthThreshold: 250,
            checkEmail: true
        },
        $store: null
    },
    findRelevantData(data) {
        let results = {};

        for(let key in data) {
            if (!data.hasOwnProperty(key)) {
                continue;
            }
            let row = data[key];
            let k = this.trimKey(key);

            if (!this.isAnExcludedField(k)
                && (this.isAnImportantField(key) || this.meetsLengthThreshold(row))
            ) {
                results[key] = row;
            }
        }

        return results;
    },
    trimKey(key) {
        return key.toString().trim().toLowerCase();
    },
    isAnExcludedField(key) {
        return this.data.options.excludedKeys.includes(key)
    },
    isAnImportantField(key) {
        return this.data.options.importantKeys.includes(key.toLowerCase());
    },
    meetsLengthThreshold(value) {
        if(!value) {
            return false;
        }
        return value.length >= this.data.options.lengthThreshold;
    },
    mapKey(key, defaultValue) {
        switch (this.trimKey(key)) {
            case 'aanhef':
            case 'preamble':
                return 'Aanhef';
            case 'salutation':
            case 'gender':
                return 'Geslacht';
            case 'adres':
            case 'address':
                return 'Adres';
            case 'postcode':
                return 'Postcode';
            case 'plaats':
                return 'Plaats';
            case 'location':
                return 'Locatie';
            case 'locations':
                return 'Locaties';
            case 'fax':
                return 'Fax-nummer';
            case 'email':
            case 'emailaddress':
            case 'mail':
                return 'E-mailadres';
            case 'workemail':
                return 'E-mailadres werk';

            case 'message':
            case 'bericht':
            case 'comment':
            case 'body':
                return 'Bericht';

            case 'anders':
            case 'othertext':
                return 'Opmerkingen';
            case 'date':
                return 'Datum';
            case 'birthday':
                return 'Geboortedatum';

            case 'job':
                return 'Vacature';
            case 'preference':
                return 'Voorkeur';
            case 'city':
                return '(Woon)plaats';

            case 'name':
            case 'naam':
                return 'Naam';

            case 'first_name':
            case 'firstname':
            case 'first':
                return 'Voornaam';

            case 'last_name':
            case 'lastname':
            case 'last':
                return 'Achternaam';

            case 'contactpersoon':
            case 'contactperson':
                return 'Contactpersoon';

            case 'company':
            case 'bedrijf':
            case 'bedrijfsnaam':
            case 'companyname':
                return 'Bedrijfsnaam';

            case 'organisation':
            case 'organization':
                return 'Organisatie';

            case 'contact':
                return 'Contactpersoon';

            case 'number':
                return 'Aantal gasten';

            case 'source':
                return 'Bron';

            case 'telefoon':
            case 'phone':
                return 'Telefoon';

            case 'org-message':
                return 'Orgineel bericht';
            case 'subject':
                return 'Onderwerp';
            case 'signature':
                return 'Handtekening';

            case 'soortfeest':
                return 'Soort bijeenkomst';

            case 'aantal':
                return 'Aantal personen';

            default:
                return defaultValue.charAt(0).toUpperCase() + defaultValue.slice(1);
        }
    },
    mapValue(key, value, defaultValue = '') {
        if(value === undefined || value === null) {
            return defaultValue;
        }
        switch (this.trimKey(key)) {
            case 'aard':
                let aard = this.data.$store.getters['aardStore/findAard'](value);
                return aard !== null ? aard.name : 'Laden...';
            case 'location':
                let location = this.data.$store.getters['locationsStore/findLocation'](value);
                return location !== null ? location.name : 'Laden...';
            case 'source':
                let source = this.data.$store.getters['selectedStore/findSource'](value);
                return source !== null ? source.label : 'Laden...';
            case 'type':
                let type = this.data.$store.getters['selectedStore/findType'](value);
                return type !== null ? type.label : 'Laden...';
            case 'salutation':
            case 'aanhef':
            case 'gender':
            case 'preamble':
                switch (this.trimKey(value)) {
                    case 'f':
                    case 'v':
                    case 'F':
                    case 'V':
                        return 'Vrouw';
                    case 'm':
                    case 'M':
                        return 'Man';
                    case 'o':
                    case 'O':
                        return 'Onbekend';
                }
        }
        return (this.isAString(value) && value.trim().length > 0 ? value : !this.isAString(value) ? value : defaultValue).replace(/&#(\d+);/g, function(match, dec) {
            return String.fromCharCode(dec);
        });
    },
    shouldShow(key) {
        return !this.data.options.hideKeys.includes(key.toLowerCase())
    },
    isANumber(str){
        return !/\D/.test(str);
    },
    isAString(str) {
        return (typeof str === 'string' || str instanceof String);
    },
    getNumberOfGuests(data) {
        let values = data.values;
        if(values.number !== undefined && values.number !== null && this.isANumber(values.number)) {
            return parseInt(values.number);
        }

        return null;
    },
    getLocation(data) {
        let values = data.values;
        if(values.location !== undefined && values.location !== null && this.isANumber(values.location)) {
            return parseInt(values.location);
        } else if(data.source && data.source.ep_location_id) {
            return data.source.ep_location_id;
        }
        return null;
    },
    getAard(data) {
        let values = data.values;
        if(values.aard !== undefined && values.aard !== null && this.isANumber(values.aard)) {
            return parseInt(values.aard);
        }
        return null;
    },
    getType(data) {
        let values = data.values;
        if(values.type !== undefined && values.type !== null && this.isANumber(values.type)) {
            return parseInt(values.type);
        } else if(data.source && data.source.ep_type_id) {
            return data.source.ep_type_id;
        }
        return null;
    },
    getSource(data) {
        let values = data.values;
        if(values.source !== undefined && values.source !== null && this.isANumber(values.source)) {
            return parseInt(values.source);
        } else if(data.source && data.source.ep_source_id) {
            return data.source.ep_source_id;
        }
        return null;
    },
    getDate(data) {
        let values = data.values;
        if(values.date !== undefined && values.date !== null && new Date(values.date)) {
            return new Date(values.date);
        }
        return moment().add(1, 'day');
    }
};